/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataflowInteraction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 2v20H2V2zm0-2H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
        <path d="M8.874 9.416v5.167h1.525c.781 0 1.325-.384 1.633-1.154.168-.423.253-.926.253-1.51 0-.805-.127-1.423-.382-1.853-.25-.433-.752-.65-1.504-.65zm1.805-1.375c.49.008.898.065 1.224.172a2.614 2.614 0 0 1 1.348 1.005c.276.394.464.82.564 1.278.1.458.15.895.15 1.31 0 1.053-.21 1.945-.633 2.675-.573.985-1.457 1.477-2.653 1.477h-3.41V8.041zm6.053 7.918h-1.644V8.042h1.644z" />
      </g>
    </g>
  </Icon>
);
export { SvgDataflowInteraction as DataflowInteraction };
